import React from "react";
import { Controller } from "react-hook-form";
import { Col, Label } from "reactstrap";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SelectCountry } from "../../Component/Form/SelectCountry/SelectCountry";

export const NationalityField = ({
  control,
  errors,
  colSize = "md-4",
  required = true,
  name = "nationality_code",
  labelKey = "NATIONALITY",
  ...InputProps
}) => {
  const { t } = useTranslation();

  return (
    <Col {...{ [colSize.split("-")[0]]: colSize.split("-")[1] }}>
      <Stack gap={1} className="mb-3">
        <Label className={`fw-bold ${required ? "required" : ""}`} for={name}>
          {t(labelKey)}
        </Label>
        <Controller
          name={name}
          control={control}
          rules={{
            ...(required && { required: t("FIELD_REQUIRED") }),
          }}
          render={({ field }) => (
            <SelectCountry
              {...field}
              id={name}
              status={errors[name] ? "error" : undefined}
              {...InputProps}
            />
          )}
        />
        {errors[name] && (
          <div className="text-danger mt-1">{errors[name].message}</div>
        )}
      </Stack>
    </Col>
  );
};
